import { ComponentRef, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular';
import { Observable, filter, from, map, merge, race, take, zip } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalCloseGuard {
  constructor(
    private readonly modalCtrl: ModalController,
    private readonly popoverCtrl: PopoverController
  ) {}

  canDeactivate(
    component: ComponentRef<any>,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return zip(
      from(this.modalCtrl.getTop()),
      from(this.popoverCtrl.getTop())
    ).pipe(
      map(([modalOverlay, popopverOverlay]) => {
        if (modalOverlay) {
          modalOverlay.dismiss();
          return false;
        }
        if (popopverOverlay) {
          popopverOverlay.dismiss();
          return false;
        }
        return true;
      })
    );
  }
}
